module.exports = __webpack_public_path__ + "img/GH-kyujin-top-ozeki.5f6a8627.jpg";